<template>
  <button
    class="icon-menu"
    tabindex="0"
    aria-label="Abrir menú lateral"
    :aria-expanded="!appState$$.isMenuCollapsed"
    @click="onCollapseMenu(false)"
    @keyup.enter="onCollapseMenu(false)"
  >
    <span
      class="icon-menu__icon pi pi-bars"
    ></span>
    <span class="icon-menu__text">
      Menú
    </span>
  </button>

  <div
    v-if="!appState$$.isMenuCollapsed"
    :class="{
      'menu-float': true,
    }"
  >
    <div
      :class="{
        'menu-float__menu': true,
        'menu-float__menu--collapse': onCollapse,
      }"
    >
      <!-- HEADER, TITLE, USER, LOGOUT -->
      <FloatMenuHeader @collapse="onCollapseMenu" />

      <Divider class="menu-float__menu__divider" />

      <!-- ITEMS -->
      <FloatMenuItems @collapse="onCollapseMenu" />

      <!-- <Divider class="menu-float__menu__divider" /> -->

      <div class="menu-float__menu__footer"></div>
    </div>
    <div
      class="menu-float__overlay"
      tabindex="0"
      @click="onCollapseMenu(true)"
      @keyup.enter="onCollapseMenu(true)"
    ></div>
  </div>
</template>

<script setup>
import {
  inject,
  shallowRef,
  watch,
} from 'vue';

import Divider from 'primevue/divider/sfc';

import FloatMenuHeader from './FloatMenuHeader.vue';
import FloatMenuItems from './FloatMenuItems.vue';

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');
const onCollapse = shallowRef(false);
// #endregion

// #region Functions
function onCollapseMenu(force = false) {
  try {
    if (force) {
      appState$$.isMenuCollapsed = true;
      return;
    }
    appState$$.isMenuCollapsed = !appState$$.isMenuCollapsed;
  } catch (e) {
    useDev.error('[FloatMenu.vue] onCollapseMenu', e);
  }
}
// #endregion

// #region Effects, Hooks
watch(
  () => appState$$.isMenuCollapsed,
  () => {
    setTimeout(() => {
      onCollapse.value = !onCollapse.value;
    }, 100);
  },
);
// #endregion

// #region Provide, Expose
defineExpose({
  onCollapseMenu,
});
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.icon-menu{
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background-color: $pv__color--yellow;
  border-radius: 4px;
  border: 0;
  cursor: pointer !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: $brand__boxspace--small;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-top: $brand__boxspace--small;
  padding: $brand__boxspace--small $brand__boxspace--medium
  $brand__boxspace--medium $brand__boxspace--medium;

  @include media(">desktop") {
    display: none !important;
  }

  &__icon{
    font-size: ($pv__fs--medium * 2);
    text-align: center;
  }

  &__text{
    text-align: center;
    font-size: $pv__fs--xlarge;
    font-weight: 100;
  }

  &:hover{
    background-color: $pv__color--yellow-hover;
  }

  &:focus{
    outline: $pv__color--black auto 5px !important;
    outline-offset: 2px;
    opacity: 1;
  }
}

.menu-float{
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 3;
  &__menu{

    background-color: $pv__color--darkblue;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    height: 100vh;
    left: 0;
    overflow-x: hidden;
    position: fixed;
    top: 0;
    -webkit-transition: width 0.5s;
    -o-transition: width 0.5s;
    transition: width 0.5s;
    width: 0;
    z-index: 4;

    &__divider{
      margin: 0rem !important
    }
    &__navigation{
      -webkit-box-flex: 5;
          -ms-flex: 5;
              flex: 5;
      &__container{
        color: $pv__color--white;
        height: 100%;
        margin: 0;
        overflow: auto;
        padding: 0;
        &__item{
          cursor: pointer;
          font-size: $pv__fs--xlarge;
          font-weight: 400;
          outline: 1px solid $pv__color--white;
          padding: 1.5rem;
        }
        &__item:hover{
          background-color: #d9d9d9;
          color: $pv__color--darkblue;
        }
      }
    }
    &__footer{
      -webkit-box-flex: 2;
          -ms-flex: 2;
              flex: 2;
      background: url('~@/assets/images/bg-menu-lateral-min.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center bottom;
    }
  }

  &__menu--collapse{
    width: $pv__dm__menu-mobile;
  }

  &__overlay{
    background-color: $pv__color--black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3;
  };
}
</style>
